<template>
    <v-container fluid grid-list-md text-xs-center>

        <v-layout justify-center row wrap style="padding: 10px;" class="hidden-xs-only">
            <v-flex x12>
                <v-img :src="require('../assets/module-en-reparation-1.png')" style="width: 500px; left: 30%"></v-img>
            </v-flex>
        </v-layout>


        <v-layout justify-center row wrap style="padding: 10px;">
            <v-flex x12>
                <v-img :src="require('../assets/module-en-reparation-1.png')"></v-img>
            </v-flex>
        </v-layout>


        <v-layout justify-center row wrap style="padding: 10px;">
            <v-flex x12>
                <h1 class="grey--text">Nous sommes sincèrement désolés!</h1>
                <h2 class="red--text">Notre module de réservation est présentement en réparation.</h2>
                <v-divider inset></v-divider>
            </v-flex>
        </v-layout>

        <v-layout justify-center row wrap style="padding: 10px;">
            <v-flex x12>
                <h1 style="color:#009688;">Quoi faire?</h1>
                </br>
                    <h2>Contactez-nous directement par téléphone, au <a href="tel://1-418-688-3311" class="decoration">
                        (418) 688-3311</a>, et vous profiterez du même service qu'en ligne.</h2>
                </br>
                <h3>Référez-vous à notre page de <a href="Particulier.vue" class="decoration">SERVICES</a>
                    pour connaître les prix et services offerts.</h3>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12>
                <v-container
                        grid-list-md
                        text-xs-center
                >
        <v-layout row wrap justify-center>
            <v-flex>
                <v-card class="align-center">
                    <v-card-text>
                        <v-icon class="blue--text darken-3">fas fa-phone</v-icon>
                        <p><h4>Heures de prise de rendez-vous</h4></p>
                        <p>
                            Lun-Mer : 9h à 17h30</br>
                            Jeu-Ven : 9h à 21h</br>
                            Sam : 9h à 17h</br>
                            Dim : 10h à 17h
                        </p>
                    </v-card-text>
                </v-card>
            </v-flex>
            </v-layout>
                </v-container>
            </v-flex>
        </v-layout>


    </v-container>
</template>

<script>
    export default {
        name: "ReparationModule"
    }
</script>

<style scoped>

</style>
